import React from 'react';
import LiveSessionPage from './LiveSessionComponents/LiveSessionPage';

const LiveSessionView = (props) => {
  return <LiveSessionPage {...props} />;
};

export default LiveSessionView;
